import React, { useEffect, useState } from "react";
import Topbar from "../../Layouts/Superadmin_layout/Superadmin_topbar";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Pagination,
  Typography,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchIcon from "@mui/icons-material/Search";
import { alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FiEye } from "react-icons/fi";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function FieldOfficersData() {
  const { id } = useParams();
  const [farmers, setFarmers] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const navigate = useNavigate();

  const handlenavigate = () => {
    navigate(`/superadmin/AllDetails/${id}`);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    if (query === "") {
      setFilteredFarmers(farmers);
    } else {
      const filtered = farmers.filter((farmer) =>
        Object.values(farmer).some((value) =>
          value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredFarmers(filtered);
    }
    setCurrentPage(1);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [farmerspage] = useState(10);
  const indexOfLastfarmer = currentPage * farmerspage;
  const indexOfFirstfarmer = indexOfLastfarmer - farmerspage;
  const currentfarmer = filteredFarmers.slice(
    indexOfFirstfarmer,
    indexOfLastfarmer
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchFarmers = async () => {
    try {
      const response = await instance.get(
        `vendor/getVendorDetails?vendor_id=${id}`
      );
      setVendorName(response.data.vendor.name);
      setFarmers(response.data.fields);
      setFilteredFarmers(response.data.fields);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFarmers();
  }, []);

  return (
    <>
      <div style={{ padding: "20px 20px 0px 0px" }}>
        <Topbar />
        <div style={{ padding: "20px 0px 0px 0px" }}>
          <section className="main_box">
            <div className="container-fluid">
              <div className="table_box">
                <TableContainer component={Paper}>
                  <div className="table_inbox">
                    <div className="add_user_list">
                      <div className="add_user_content">
                        <div
                          style={{
                            fontFamily: "Poppins,sans-serif",
                            fontSize: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          Fields of {vendorName}
                        </div>
                      </div>
                      <div className="add_user">
                        <div>
                          <Search>
                            <SearchIconWrapper>
                              <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                              type="search"
                              placeholder="Search…"
                              inputProps={{ "aria-label": "search" }}
                              value={search}
                              onChange={handleSearch}
                            />
                          </Search>
                        </div>
                        <Button
                          className="table-button"
                          variant="outlined"
                          onClick={handlenavigate}
                        >
                          Back
                        </Button>
                      </div>
                    </div>
                    <Table
                      className="adduser_table user_table product_table"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow className="table_head">
                          <TableCell align="center" className="first-child">
                            Sl.No
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Village Name
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Mandal Name
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Type Of Customer
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Plantation Date
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Area (Ha)
                          </TableCell>
                          <TableCell align="center">Initial Visit</TableCell>
                          <TableCell align="center">Last Visit</TableCell>
                          <TableCell align="center">
                            Plantation Status
                          </TableCell>
                          <TableCell align="center">
                            View Field Details
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="table_body">
                        {currentfarmer.length > 0 ? (
                          currentfarmer.map((farmer, index) => (
                            <TableRow key={farmer._id}>
                              <TableCell align="center">
                                {index + 1 + (currentPage - 1) * farmerspage}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.village_name}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.mandal_name}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.type_of_customer}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.plantation_date ?
                                  new Date(farmer?.plantation_date)
                                    .toISOString()
                                    .split("T")[0] : '---'
                                }
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.area_in_acres}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.createdAt ?
                                  new Date(farmer?.createdAt)
                                    .toISOString()
                                    .split("T")[0] : '---'
                                }
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.updatedAt ?
                                  new Date(farmer?.updatedAt)
                                    .toISOString()
                                    .split("T")[0] : '---'
                                }
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.plantation_status}
                              </TableCell>
                              <TableCell align="center">
                                <Link
                                  className="farmer-details"
                                  to={`/superadmin/FieldDetails/?field_hash=${farmer.hash}&vendor_id=${farmer.vendor._id}`}
                                >
                                  <FiEye className="view-icon" />
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableCell colSpan={12} align="center">
                            <Typography>No matched items</Typography>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                    <div className="pagination_table">
                      <Pagination
                        count={Math.ceil(filteredFarmers.length / farmerspage)}
                        page={currentPage}
                        onChange={(event, page) => paginate(page)}
                        shape="rounded"
                        variant="outlined"
                      />
                    </div>
                  </div>
                </TableContainer>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default FieldOfficersData;
